"use strict";
exports.__esModule = true;
exports.defaultCacheUrls = void 0;
exports.defaultCacheUrls = [
    {
        hostname: 'yandexwebcache.net',
        pathname: '/yandbtm',
        getRealUrl: function (url) {
            var parsed = new URL(url);
            return parsed.searchParams.get('url');
        }
    },
    {
        hostname: 'webcache.googleusercontent.com',
        pathname: '/search',
        getRealUrl: function (url) {
            var parsed = new URL(url);
            var q = parsed.searchParams.get('q');
            var matched = q.match(/^cache:[^:]+:(.+)/);
            if (!matched)
                throw new Error("Can't extract realUrl from \"" + url + "\"");
            var extracted = matched[1].trim();
            if (!extracted.startsWith('https://'))
                return "http://" + extracted;
            return extracted;
        }
    },
];
//# sourceMappingURL=config.js.map